import { EmployeeTimetableModelType } from '@teinor/erp/types/company/userInner/employee/employeeTimetable';
import { TableRowProps } from 'react-virtualized';
import { defaultRowRenderer } from 'react-virtualized/dist/es/Table';
import { EmployeeJourneyTyExtended } from '../../../app/erp/screens/Staff/WorkingCalendarParent/TimeControlEmployeeMonth/types';
import { parseStringDateHoursToMins } from '../../../utils/globals/date';
import { EmployeeJourneyByYearResult } from './TableControlYearWork/types';

export const timeControlEmployeeMonthRowRender = (props: TableRowProps) => {
    let className = props.className
    const type = props?.rowData?.type
    const isNotFreeDay = type === 'normalDay' || (type === 'specialDay' && props.rowData?.journey?.workingTime?.length) || type === 'absenceDay' || type === 'absenceJustifiedDay' || props.rowData?.journey?.overtimePosition?.length || (type === 'holidayDay' && props.rowData?.isHalfDay && props.rowData?.journey?.workingTime?.length)
    if (props?.rowData?.type === 'totals') {
        className += ' bg-gray-F7 total_month_row flex items-center regular24'
    } else if (!isNotFreeDay){
        className += ' bg-gray-F7'
    }
    return defaultRowRenderer({ ...props, className })
}
export const timeControlEmployeeMonthYearRowRender = (props: TableRowProps) => {
    let className = props.className
    if (props?.rowData?.type === 'totals') {
        className += ' bg-gray-F7 total_year_row flex items-center regular24'
    }
    return defaultRowRenderer({ ...props, className })
}

export const getTotalMonthData = (monthData: EmployeeJourneyTyExtended[]) => {
    const now = new Date()
    let totalMinsToDo = 0
    let totalJustifiedMins = 0
    let balanceMinsToDo = 0
    let balancePermittedMinsToDo = 0
    let totalMinsWorked = 0
    let totalMinsPermittedWorked = 0
    let totalOvertimeMins = 0
    for (const day of monthData) {
        if (day?.journey?.workingTime) {
            totalMinsToDo += day.dayMins || 0
            day.totalMinsToDo = day.dayMins || 0
            totalJustifiedMins += day.justifiedMins || 0
            day.totalJustifiedMins = day.justifiedMins || 0
            const totalMinsWorkedToday = day.totalDayTime || 0
            const totalMinsPermittedWorkedToday = day.totalTimePermitted || 0
            day.totalMinsWorked = totalMinsWorkedToday
            totalOvertimeMins += day.overtimeMins || 0
            day.totalOvertimeMins = day.overtimeMins || 0
            day.balance = totalMinsWorkedToday - (day.totalMinsToDo + (day.totalOvertimeMins || 0) - (day.totalJustifiedMins || 0))
            day.balancePermitted = totalMinsPermittedWorkedToday - (day.totalMinsToDo + (day.totalOvertimeMins || 0) - (day.totalJustifiedMins || 0))
            if (now > new Date(day.date)) {
                balanceMinsToDo += day.balance
                balancePermittedMinsToDo += day.balancePermitted
            }
            totalMinsWorked += totalMinsWorkedToday
            totalMinsPermittedWorked += totalMinsPermittedWorkedToday
        }
    }
    return {
        totalMinsToDo, balanceMinsToDo, totalMinsWorked, totalMinsPermittedWorked, balancePermittedMinsToDo, totalOvertimeMins, totalJustifiedMins
    }
}

export const getTotalYearData = (yearData: EmployeeJourneyByYearResult[]) => {
    let totalMinsToDo = 0
    let totalJustifiedMins = 0
    let balanceMinsToDo = 0
    let balancePermittedMinsToDo = 0
    let totalMinsWorked = 0
    let totalMinsPermittedWorked = 0
    let totalOvertimeMins = 0
    const totalAgreementMins = yearData?.[0]?.totalAgreementMins
    const restAgreementMins = yearData?.[0]?.restAgreementMins || 0
    for (const month of yearData) {
        totalMinsWorked += month.totalMinsWorked
        totalMinsToDo += month.totalMinsToDo
        totalJustifiedMins += month.totalJustifiedMins
        totalMinsPermittedWorked += month.totalMinsPermittedWorked
        balanceMinsToDo += month.balanceMinsToDo
        balancePermittedMinsToDo += month.balancePermittedMinsToDo
        totalOvertimeMins += month.totalOvertimeMins || 0
    }
    if (totalAgreementMins || restAgreementMins) {
        const myExtraMins = totalAgreementMins ? totalMinsToDo - totalAgreementMins : 0
        balanceMinsToDo = balanceMinsToDo - restAgreementMins + myExtraMins
        balancePermittedMinsToDo = balancePermittedMinsToDo - restAgreementMins + myExtraMins
    }
    return {
        totalMinsToDo, balanceMinsToDo, totalMinsWorked, totalMinsPermittedWorked, balancePermittedMinsToDo, totalOvertimeMins, totalJustifiedMins, restAgreementMins, totalAgreementMins
    }
}
export const parseStartAndEndTime = (timetable: EmployeeTimetableModelType) => {
    let startMin = 0
    let endMin = 0
    startMin = parseInt(parseStringDateHoursToMins(timetable.edited_start_time || timetable.og_start_time))
    if (timetable.edited_end_time || timetable.og_end_time) {
        endMin = parseInt(parseStringDateHoursToMins(timetable.edited_end_time || timetable.og_end_time || '0'))
    }
    return { startMin, endMin }
}